'use strict';
import stringify from 'json-stringify-safe';
/**
 * Controller, resolves and related functionality for the error view.
 */

export default function ($scope, $location, Application) {
  $scope.errorInfo = Application.currentErrorInfo;
  Application.currentErrorInfo = undefined;

  var isErrorObject = function (error) {
    return error !== undefined && error.cause !== undefined;
  };

  $scope.rawError = stringify(($scope.errorInfo || {}).error, null, 2);

  var deCamelCase = function (string) {
    if (typeof string !== 'undefined') {
      return string.replace(/(^.|[A-Z])/g, function (match, subMatch, offset) {
        if (!offset) {
          return match.toUpperCase();
        }

        return (' ' + match).toLowerCase();
      });
    }

    return string;
  };

  // Information from the error info object

  if ($scope.errorInfo !== undefined && isErrorObject($scope.errorInfo.error)) {
    console.warn('Error:', $scope.errorInfo.error);

    $scope.errorMessage = $scope.errorInfo.error.cause;

    $scope.errorType = deCamelCase($scope.errorInfo.error.type);
    $scope.errorSeverity = deCamelCase($scope.errorInfo.error.severity);

    if ($scope.errorInfo.error.type === atex.aceui.error.types.PERMISSION_DENIED) {
      $scope.errorHeader = 'Permission denied';
      $scope.errorMessage = 'You do not have sufficient privileges. If this is a mistake, please contact your administrator.';
    }
  }

  $scope.goBack = function () {
    $location.path('/');
  };
}
